import React, { FunctionComponent, useRef, useEffect } from 'react';
import useElementsShowInView from '@modules/ui/shared/hooks/useElementsShowInView';

const AppRightNavWithContents = ({ children }: { children: React.ReactElement }) => {
  const removeMouseHandlerRef = useRef<null | (() => void)>(null);
  const { enable, disable } = useElementsShowInView();
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const removeMouseHandler = () => {
      if (removeMouseHandlerRef.current) {
        removeMouseHandlerRef.current();
      }
    };
    removeMouseHandler();
    const mouseEnter = disable;
    const mouseLeave = enable;
    if (ref.current) {
      ref.current.addEventListener('mouseenter', mouseEnter);
      ref.current.addEventListener('mouseleave', mouseLeave);

      removeMouseHandlerRef.current = () => {
        if (ref.current) {
          ref.current.removeEventListener('mouseenter', mouseEnter);
          ref.current.removeEventListener('mouseleave', mouseLeave);
        }
      };
    }
    return removeMouseHandler;
  }, [children, disable, enable]);

  return children;
};

const AppRightNav: FunctionComponent<React.PropsWithChildren<{ content?: React.ReactElement }>> = ({
  content,
}) => {
  return content ? <AppRightNavWithContents>{content}</AppRightNavWithContents> : null;
};

export default AppRightNav;
